import { useContext } from 'react';
import { CoreConfigContext } from '../context/CoreConfigProvider';
export const useCoreConfigProvider = () => {
    const value = useContext(CoreConfigContext);
    if (!value) {
        throw new Error('No config');
    }
    return value;
};
